(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6011],{

/***/ 1874:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flight-schedule/[[...param]]",
      function () {
        return __webpack_require__(2954);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4953);




// Dynamic imports for components
var FlightRouteDT = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2987).then(__webpack_require__.bind(__webpack_require__, 2987));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2987)
            ];
        }
    }
});
var FlightRoutePWA = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 3682).then(__webpack_require__.bind(__webpack_require__, 3682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3682)
            ];
        }
    }
});
var FareFinderDT = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8827).then(__webpack_require__.bind(__webpack_require__, 8827));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8827)
            ];
        }
    }
});
var FlightDistanceDT = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 9562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9562)
            ];
        }
    }
});
var CityDT = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 3617).then(__webpack_require__.bind(__webpack_require__, 3617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3617)
            ];
        }
    }
});
var CityCountryDT = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 3543).then(__webpack_require__.bind(__webpack_require__, 3543));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3543)
            ];
        }
    }
});
var Offers = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7607).then(__webpack_require__.bind(__webpack_require__, 7607));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7607)
            ];
        }
    }
});
var FlightDistancePWA = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2650).then(__webpack_require__.bind(__webpack_require__, 2650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2650)
            ];
        }
    }
});
var CityPWA = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9733).then(__webpack_require__.bind(__webpack_require__, 9733));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9733)
            ];
        }
    }
});
var FlightStatusPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7824).then(__webpack_require__.bind(__webpack_require__, 7824));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7824)
            ];
        }
    }
});
var FlightStatusPWA = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5837).then(__webpack_require__.bind(__webpack_require__, 5837));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5837)
            ];
        }
    }
});
function Body(props) {
    var data = (props || {}).data;
    var ref = data || {}, pageType = ref.pageType, isDeviceMobile = ref.isDeviceMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            pageType === "offerPage" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Offers, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightStatusPageType */ .w4b[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightStatusPage, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightStatusPageType */ .w4b[pageType] && isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightStatusPWA, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightsIsmDTNewPageType */ .Py9[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightRouteDT, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightsIsmDTNewPageType */ .Py9[pageType] && isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightRoutePWA, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .fareFinderDTPageType */ .T11[pageType] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FareFinderDT, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightIsm2PageType */ .SAi[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightDistanceDT, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightIsm2PageType */ .SAi[pageType] && isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightDistancePWA, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightsStaticPageType */ ._j[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CityDT, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .flightsStaticPageType */ ._j[pageType] && isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CityPWA, {
                data: data
            }),
            _utils_Constants__WEBPACK_IMPORTED_MODULE_2__/* .destinationPickerDTPageType */ .eA_[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CityCountryDT, {
                data: data
            })
        ]
    });
}
Body.propTypes = {
    // eslint-disable-next-line react/require-default-props, react/forbid-prop-types, react/no-unused-prop-types
    props: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};


/***/ }),

/***/ 2954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PageView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _containers_Body__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2668);


var __N_SSP = true;
function PageView(param) {
    var data = param.data, localeSettings = param.localeSettings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Body__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            data: data
        })
    });
}
 // PageView.propTypes = {
 // 	data: PropTypes.object,
 // };


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1874); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);